var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButtonCircle',{nativeOn:{"click":function($event){return _vm.share($event)}}},[_c('img',{attrs:{"src":require("@/assets/img/facebook.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }